import db from "@/plugins/dexie";
import { USER_STORAGE  } from '@/constants/STORAGE'
import apivarejoweb from '@/services/api-varejoweb';
import moment from "moment-timezone";
import store from "@/store";
// import geraDataV2 from "../geraDataV2";

import $_enviaImagem from "./enviaImagem";

function getSessionStorage(key, defaultValue) {
  return sessionStorage.getItem(key) ?? defaultValue;
}
// Só colocar o nome da tabela onde está a variável
// Ex db.usuario.toArray()
const tabela = 'ordemservicoitem';
const idnuvem = 'osiidnuvem';
export default async function $_enviaColetaItem(osiidordemservicolocal) {
  const token = JSON.parse(sessionStorage.getItem('auth:token'));
  let unidades = await db[tabela].toArray();
  unidades = unidades.filter(i => i.osidatanuvem === null && !i.osiexclusao);
  
  if (osiidordemservicolocal) {
    if (Array.isArray(osiidordemservicolocal)) {
      unidades = unidades.filter(i => osiidordemservicolocal.includes(i.osiidordemservicolocal));
    } else {
      unidades = unidades.filter(i => i.osiidordemservicolocal === osiidordemservicolocal);
    }
  }
  const idusuario = await getSessionStorage(USER_STORAGE.useidusuario);

  // Cria um array de Promises
  const promises = unidades.map(async (item) => {
    const payload = {
      // monta o payload para salvar no banco
      IDPRODUTO: item.osiidproduto,
      DataItem: item.osidatainclusao,
      IDORDEMSERVICO: item.osiidordemserviconuvem,
      DescricaoComplementar: item.osiobservacao,
      QUANTIDADE: item.osiquantidade,
      PRECOUNITARIO: item.osivalorunitario,
      DESCRICAOITEM: item.osidescricao,
      item: item.osiordem,

      IOSIdUsuarioCadastro: idusuario,
    };

    // Verifica se o item que ta mandando já tem um id nuvem (já foi salvo na Amazon)
    if (item[idnuvem] && item[idnuvem] !== 'null') payload.id = item[idnuvem];

    let res = null;
    try {
      if (item[idnuvem] && item[idnuvem] !== 'null') {

        res = await apivarejoweb.put(`/ordemservicoitem/${item[idnuvem]}`, payload, {
          headers: { Authorization: `Bearer ${token.token}` }
        });
      } else {
        res = await apivarejoweb.post('/ordemservicoitem', payload, {
          headers: { Authorization: `Bearer ${token.token}` }
        });
      }
    } catch (err) {
      console.log(err);
    }

    if (res) {
      const alteracao = moment(res.data.osidataalteracao).format('YYYY-MM-DD HH:mm:ss.SSS');
      await db[tabela].update(item.id, {
        osiidusuario: res.data.idusuario,
        osiidnuvem: res.data.id ?? item[idnuvem],
        osidataalteracao: alteracao,
        osidatanuvem: alteracao,
      });
      store.dispatch('cache/atualizaData', { data: alteracao, tabela: `${tabela}` });
      await store.dispatch('cache/reloadCache', 'ordemservicoitem')
    }
  });

  // Aguarda todas as requisições terminarem
  const retorno = await Promise.all(promises);

  // Pode enviar outras funções do atualiza local aqui,
  // Caso queira que executa somente após tudo acima for enviado
  if (retorno.length > 0) {   
      await $_enviaImagem();
    }
  
}

// Caso seja possível deletar também
export async function $_deletaColetaItem() {
  const token = JSON.parse(sessionStorage.getItem('auth:token'));
  let unidades = await db[tabela].toArray();
  unidades = unidades.filter(o => o.osiexclusao);
  unidades.forEach((item) => {
    apivarejoweb.delete(`/ordemservicoitem/app/${item[idnuvem]}`, {
      headers: {
          Authorization: `Bearer ${token.token}`
      }
  }).then((res) => {
      console.log(res, 'res');
      db[tabela].where({id: item.id}).delete();
  });
  })
}